import { render, staticRenderFns } from "./WaitingFlag.vue?vue&type=template&id=c7cf2506&scoped=true"
import script from "./WaitingFlag.vue?vue&type=script&lang=js"
export * from "./WaitingFlag.vue?vue&type=script&lang=js"
import style0 from "./WaitingFlag.vue?vue&type=style&index=0&id=c7cf2506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cf2506",
  null
  
)

export default component.exports